<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">1 公共状态码</h1>
		<frm-Error-Code :propsTableData='CommonStatusCode'></frm-Error-Code>
		<h1 class="doc_main_h1">2 业务状态码</h1>
		<h3 class="doc_main_h3">2.1账号管理模块</h3>
		<frm-Error-Code :propsTableData='BusinessStatusCode'></frm-Error-Code>
		<h3 class="doc_main_h3">2.2项目管理模块</h3>
		<frm-Error-Code :propsTableData='ProjectManagementModule'></frm-Error-Code>
		<h3 class="doc_main_h3">2.3人员管理模块</h3>
		<frm-Error-Code :propsTableData='PersonnelManagementModule'></frm-Error-Code>
		<h3 class="doc_main_h3">2.4终端管理模块</h3>
		<frm-Error-Code :propsTableData='TerminalManagementModule'></frm-Error-Code>
		<h3 class="doc_main_h3">2.5人脸分析模块</h3>
		<frm-Error-Code :propsTableData='FaceAnalysisModule'></frm-Error-Code>
		<h3 class="doc_main_h3">2.6消息推送</h3>
		<frm-Error-Code :propsTableData='MessagePush'></frm-Error-Code>

		
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnvalueTable';	
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,		
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','状态码'],
				//公共状态码
				CommonStatusCode:[
					{"Statuscode":"0","errormessage":"success","msg":"请求成功"},
					{"Statuscode":"1","errormessage":"缺少参数：具体缺少的参数","msg":"缺少请求必填参数"},
					{"Statuscode":"2","errormessage":"参数错误：格式错误，范围错误等","msg":"请求参数格式错误、范围超出、不可重复字段重复等"},
					{"Statuscode":"3","errormessage":"token无效","msg":"token错误"},
					{"Statuscode":"4","errormessage":"服务器内部错误","msg":"服务器内部错误，请稍后重试"}
				],
				//业务状态码
				BusinessStatusCode:[
					{"Statuscode":"1001","errormessage":"账号被禁用","msg":"账号被禁用"},
					{"Statuscode":"1002","errormessage":"account_name无效","msg":"账号不存在"},
					{"Statuscode":"1003","errormessage":"密码错误","msg":"密码错误"},
					{"Statuscode":"1004","errormessage":"account_id无效","msg":"账号不存在"},
					{"Statuscode":"1005","errormessage":"没有创建子账号的权限","msg":"没有创建子账号的权限"},
					{"Statuscode":"1006","errormessage":"子账号数量超限","msg":"上级账号可创建的子账号数量上限为100个"},
					{"Statuscode":"1007","errormessage":"subaccount_id无效","msg":"子账号不存在"},
					{"Statuscode":"1008","errormessage":"upaccount_id无效","msg":"上一级账号不存在"},
				],
				ProjectManagementModule:[
					{"Statuscode":"2001","errormessage":"项目数量超限","msg":"每个账号可直接管理的项目数量上限为500个"},
					{"Statuscode":"2002","errormessage":"adminaccount_id无效","msg":"管理者不存在"},
					{"Statuscode":"2003","errormessage":"project_id无效","msg":"项目不存在"},
				],
				PersonnelManagementModule:[
					{"Statuscode":"3001","errormessage":"person_id/person_ids无效","msg":"人员不存在"},
					{"Statuscode":"3002","errormessage":"group_id/dst_group_id/group_ids/pgroup_id无效","msg":"人员组不存在"},
					{"Statuscode":"3003","errormessage":"项目人员超限","msg":"项目人员总数上限为10万人"},
					{"Statuscode":"3004","errormessage":"人员组数量超限","msg":"每个人员组的同级子组数量上限为100个"},
					{"Statuscode":"3005","errormessage":"人员组层级超限","msg":"人员组层级上限为10层"},
				],
				TerminalManagementModule:[
					{"Statuscode":"4001","errormessage":"terminal_id/terminal_ids无效","msg":"终端不存在"},
					{"Statuscode":"4002","errormessage":"group_id/dst_group_id/group_ids/tgroup_id无效","msg":"终端组不存在"},
					{"Statuscode":"4003","errormessage":"终端数量超限","msg":"一个终端组下的终端数上限为2万个"},
					{"Statuscode":"4004","errormessage":"终端组数量超限","msg":"每个终端组的同级子组数量上限为100个"},
					{"Statuscode":"4005","errormessage":"终端组层级超限","msg":"终端组层级上限为10层"},
				],
				FaceAnalysisModule:[
					{"Statuscode":"5001","errormessage":"人脸图片总数超限","msg":"每个人员人脸图片总数上限为10个"},
					{"Statuscode":"5002","errormessage":"未检测到人脸","msg":"未检测到人脸，请更换图片"},
					{"Statuscode":"5003","errormessage":"图片质量差","msg":"图片质量差，请更换图片"},
					{"Statuscode":"5004","errormessage":"人脸检测服务器异常","msg":"人脸检测服务器异常，请稍后重试"},
					{"Statuscode":"5005","errormessage":"图片格式有误","msg":"支持jpg、png格式的图片"},
					{"Statuscode":"5006","errormessage":"检测到人脸不完整","msg":"人脸不完整，请更换图片"},
					{"Statuscode":"5007","errormessage":"检测到多张人脸","msg":"不可包含多张人脸，请更换图片"},
					{"Statuscode":"5008","errormessage":"检测到人脸比例太小","msg":"图片中人脸比例太小，请更换图片"},
					{"Statuscode":"5009","errormessage":"检测到人脸模糊","msg":"人脸不清晰，请更换图片"},
					{"Statuscode":"5010","errormessage":"检测到人脸戴墨镜","msg":"不可佩戴墨镜，请更换图片"},
					{"Statuscode":"5011","errormessage":"图片过大","msg":"图片不能超过4MB，请更换图片"},
					{"Statuscode":"5012","errormessage":"终端组层级超限","msg":"不可戴口罩，请更换图片"},
					{"Statuscode":"5013","errormessage":"检测到人脸姿态不合格","msg":"人脸姿态不正，请更换图片"},
					{"Statuscode":"5014","errormessage":"检测到人脸有遮挡","msg":"不可有遮挡，请更换图片"},
				],
				MessagePush:[
					{"Statuscode":"6001","errormessage":"推送服务器内部错误","msg":"推送服务器内部错误"},
					{"Statuscode":"6002","errormessage":"推送服务器连接失败","msg":"推送服务器连接失败"},
					{"Statuscode":"6003","errormessage":"udid无效","msg":"唯一设备号不存在"},
					{"Statuscode":"6004","errormessage":"推送响应超时","msg":"推送响应超时"},
					{"Statuscode":"6005","errormessage":"推送服务器繁忙","msg":"推送服务器繁忙"},
					{"Statuscode":"6006","errormessage":"推送终端不在线","msg":"推送终端不在线"},
					{"Statuscode":"6007","errormessage":"推送消息失败","msg":"远程设备可能处于离线"},
					{"Statuscode":"6008","errormessage":"推送终端无应答","msg":"推送可能无法抵达"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/StatusCode/StatusCode.vue